module.exports = __webpack_public_path__ + "static/media/DFMing-Bd-HK-BF.cb163f4f.svg";